export default [
  {
    question: 'What is a Specialization?',
    answer:
      'A Specialization is a group of related courses designed to help you deepen your expertise in a subject. You will earn a Specialization Certificate when you successfully earn a Course Certificate for each course in a Specialization and complete the Capstone Project.',
  },
  {
    question: 'How do I complete a Specialization?',
    answer:
      'To complete a Specialization, you must earn a Course Certificate for every course in the Specialization and complete the Capstone Project. The Capstone Project is available after you’ve completed all courses in the Specialization.',
  },
  {
    question: 'What is the Capstone Project?',
    answer:
      'A Capstone Project is an assignment designed specifically to apply and showcase the skills you learned in the Specialization. Every Specialization ends with a Capstone Project.',
  },
  {
    question: 'What is a Specialization Certificate?',
    answer:
      'A Specialization Certificate is an electronic document issued by the participating school and Coursera that demonstrates you have successfully completed a group of related courses (plus a Capstone Project) in a specific subject. It also links your accomplishment to your real identity. You will not receive a Course Certificate upon completion of the Capstone Project, but instead the Specialization Certificate.',
  },
  {
    question: 'How do I pay for the Specialization?',
    answer:
      'There are two payment options. You can pay once for the whole Specialization, or you can pay individually for each course as you progress.',
  },
  {
    question: 'Can I take the Specialization for free?',
    answer:
      'No, the Specialization is a premium product, but <a href="{financialAidLink}" target="_blank">financial aid</a> is available to all learners with demonstrated need. To preview material in each course, visit the course description pages.',
  },
  {
    question: 'What is the refund policy?',
    answer:
      'You are eligible for a full refund until two weeks after payment, or until two weeks after the first course in the Specialization opens, whichever is later. You are not eligible for a refund after you earn your Course Certificate, even if you complete the course within the two-week refund period. View the full <a href="{refundPolicyLink}" target="_blank">refund policy</a>.',
  },
];
